import { Icon } from '@components/ui/Icon/Icon';
import { RiskIndicatorEnum, RiskIndicatorType } from '@types';

export const riskIndicators: RiskIndicatorType[] = [
  {
    title: 'Performance',
    name: 'performance',
    color: '#B39DDBb4',
    hoverColor: '#B39DDBd4',

    href: 'https://calvin-risk.notion.site/Performance-metrics-tests-00046edf941440a2be0991e247132368',
    icon: <Icon name="chartbar" />,
    info: 'Performance risk is when the AI model fails or performs inadequately. We measure performance via traditional performance metrics. These depend on the task and type of the algorithm. So far, we consider performance metrics for classification and regression, which covers most tasks.',
    type: RiskIndicatorEnum.model,
  },

  {
    title: 'Fairness',
    name: 'fairness',
    color: '#6f9ee6b4',
    hoverColor: '#6f9ee6d4',
    href: 'https://calvin-risk.notion.site/Fairness-metrics-tests-ad9f84701551429a9e61da3f34902704',
    icon: <Icon name="scales" />,
    info: 'Fairness risk is defined as ensuring that AI models are non-discriminatory or fair with respect to a sensitive feature. There are two, in some cases mutually exclusive, fairness concepts – individual and group fairness. In the first case, individuals are treated as equal if they are equal regardless of their characteristics. In the second case, the aim is to treat groups as a whole equally.',
    type: RiskIndicatorEnum.model,
  },
  {
    title: 'Robustness',
    color: '#9FA8DAb4',
    hoverColor: '#9FA8DAd4',
    name: 'robustness',
    href: 'https://calvin-risk.notion.site/Robustness-Security-metrics-ad96d14ebd1441c5b3d352acc8945511',
    icon: <Icon name="link" />,
    info: 'Robustness means that outputs should not deviate for "small" perturbations in the feature space. The definition of "small" can mean different things for different context. Most common definitions are related to "small" with respect to some $L_p$- norm.',
    type: RiskIndicatorEnum.model,
  },
  {
    title: 'Explainability',
    name: 'explainability',
    color: '#7DBFD7b4',
    hoverColor: '#7DBFD7d4',
    href: 'https://calvin-risk.notion.site/Explainability-Transparency-metrics-d46ec99573074acea061a5e3ab09ed9d',
    icon: <Icon name="chip" />,
    info: "Explainability risk is concerned with the interpretability and transparency of a given AI model. Although 'black box' type models are not inherently risky, they raise some governance and ethical questions. The opaqueness can leave users, governments and affected parties without the facts that they need to accurately assess the risk that is being undertaken.",
    type: RiskIndicatorEnum.model,
  },
];
